import { render, staticRenderFns } from "./ApplicationDetail.vue?vue&type=template&id=f6c0ab32&scoped=true"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetail.vue?vue&type=style&index=0&id=f6c0ab32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c0ab32",
  null
  
)

export default component.exports